import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      component="footer"
      py={2}
      pb={1}
      mt={4}
    >
      <VuiBox mb={{ xs: 1, lg: 0 }}>
        <VuiTypography
          variant="button"
          sx={{ fontWeight: "400 !important", opacity: 0.7 }}
          color="white"
        >
          &copy; 2026 Intent Web &bull; High-Performance Static Web Hosting
        </VuiTypography>
      </VuiBox>
      <VuiBox display="flex" justifyContent="center" flexWrap="wrap">
        <VuiBox mr={{ xs: "16px", lg: "32px" }}>
          <VuiTypography
            component="a"
            href="https://web.int.yt"
            target="_blank"
            rel="noreferrer"
            variant="body2"
            color="white"
            sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
          >
            Documentation
          </VuiTypography>
        </VuiBox>
        <VuiBox mr={{ xs: "16px", lg: "32px" }}>
          <VuiTypography
            component="a"
            href="https://dns.int.yt"
            target="_blank"
            rel="noreferrer"
            variant="body2"
            color="white"
            sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
          >
            Intent DNS
          </VuiTypography>
        </VuiBox>
        <VuiBox>
          <VuiTypography
            component="a"
            href="https://int.yt"
            target="_blank"
            rel="noreferrer"
            variant="body2"
            color="white"
            sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
          >
            Intent Network
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </VuiBox>
  );
}

export default Footer;
